<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="archivoSeleccionado != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Estas seguro de enviar el comprobante de pago
                                <strong>{{ archivoSeleccionado.name }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al confirmar, se le notificara al administrador para que valide el estado del pago.
                        </p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateCxc()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 600px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles de la cuenta por Pagar</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" ref="stepper" header-nav bordered class="shadow-0" color="primary"
                        animated>
                        <q-step :name="1" title="Factura" icon="settings" :done="done1">
                            <q-card class="shadow-0" v-if="selectCuenta != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Factura</div>
                                </q-card-section>
                            </q-card>
                        </q-step>
                        <q-step :name="2" title="Comprabante de Pago" icon="create_new_folder" :done="done2">
                            <q-card class="shadow-0" v-if="selectCuenta != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Comprobante de Pago</div>
                                </q-card-section>
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="col-12 col-md-12">
                                        <q-file v-model="archivoSeleccionado" dense outlined
                                            label="Subir comprobante de pago" class="full-width">
                                        </q-file>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <!-- BOTONES DE ACCIONES -->
                        <template v-slot:navigation>
                            <q-stepper-navigation class="row">
                                <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                                <q-space />
                                <q-btn flat class="q-ml-sm" color="primary" label="Guardar Comprobante"
                                    @click="dialogConfirmacion = true" />
                            </q-stepper-navigation>
                        </template>
                    </q-stepper>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md full-height ">
            <div class="col-12" style="height: 100%; overflow-y: auto;">
                <q-table dense title="Cuentas Por Pagar" class="shadow-1" :data="dataList" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetCxCXid()" no-caps
                            class="q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto
                                }}</q-td>
                            <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{ props.row.tipo ?
                                props.row.tipo.toUpperCase() : ''
                            }}</q-td>
                            <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacreacion) }}</q-td>
                            <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                            <q-td key="estado" :props="props">
                                <q-badge v-if="props.row.estado == 'XC'" color="orange" label="Cuenta por Pagar" />
                                <q-badge v-if="props.row.estado == 'V'" color="purple" label="Validando Pago" />
                                <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
export default {
    components: {
    },
    data() {
        return {
            step: 1,
            loading: false,
            dataList: [],
            columns: [
                { name: 'nombre', label: 'Cliente', field: 'nombre', align: 'center', sortable: true },
                { name: 'concepto', label: 'Concepto', field: 'concepto', align: 'center', sortable: true },
                { name: 'monto', label: 'Monto', field: 'monto', align: 'right', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechacreacion', label: 'Fecha de creación', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'fechamaximapago', label: 'Fecha maxima de pago', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'estado', label: 'Estatus', field: 'estado', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            done1: false,
            done2: false,
            selectCuenta: null,
            dialogDetalles: false,
            archivoSeleccionado: null,
            dialogConfirmacion: false
        }
    },
    async mounted() {
    },
    computed: {
        userStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetCxCXid()
    },
    methods: {
        async UpdateCxc() {
            const archivo = this.archivoSeleccionado;

            if (!archivo) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Debes seleccionar un archivo primero.',
                    position: 'top-right'
                });
                return;
            }

            const base64 = await this.convertirABase64(archivo);
            let nombre_archivo = archivo.name;
            let archivo64base = base64;

            let objeto = {
                id: this.selectCuenta._id,
                imagen: archivo64base,
                nombre: nombre_archivo
            }
            console.log(objeto)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Subiendo comprobante de pago. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('CXC/SubeEvidenciaCxc', objeto)
                console.log(respuesa)
                this.$q.loading.hide()

                this.selectCuenta.estado = 'V'
                const index = this.dataList.findIndex(p => p._id === this.selectCuenta._id)
                this.$set(this.dataList, index, { ...this.selectCuenta })

                this.archivoSeleccionado = null

                this.dialogConfirmacion = false
                this.dialogDetalles = false
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se envio el comprobante, debera esperar a que sea validado.` });
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar el comprobante, intentelo de nuevo.` });
                console.log(error)
            }

        },
        async verItem(item) {
            if (item.estado == 'V') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Su cuenta por pagar esta en proceso de validación del pago. Consulte mas tarde...', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
                return
            }
            if (item.estado == 'P') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Su pago fue realizado correctamente...', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            this.selectCuenta = item
            this.dialogDetalles = true
            this.$q.loading.hide()
        },

        async GetCxCXid() {
            this.loading = true
            try {
                let respuesa = await axios.get('CXC/GetCxCXid/' + this.userStore._id)
                console.log(respuesa)
                this.loading = false
                if (respuesa.data.lista) {
                    this.dataList = respuesa.data.lista
                }
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}

.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>